<template>
  <div v-if="selected" class="gravestone-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected pr-2" :class="{ open: open }" @click="open = !open">
      <div class="d-flex">
        <img style="width: 120px;" alt="Gravsten" :src="getPic(selected.file_name)">
        <img style="width: 120px; position: absolute;" alt="Gravsten" :src="getPic(selected.file_name)">
        <div class="ml-05">
          <span class="headline">{{ selected.name }}</span>
          <br>
          <span>{{ selected.description }}</span>
        </div>
      </div>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <template v-for="(option, i) of options">
        <template v-if="!option.is_edging && !(option.has_edge_treatment_option && option.description == 'Råhuggen kant') ">
          <div class="item" :key="i" @click="
            selected = option;
            open = false;
            selectGravestone(option)
          ">
            <div :class="'d-flex ' + (option.id == selected.id ? 'active' : '')">
              <img style="width: 120px;" alt="Gravsten" class="gravestone-small-image" :src="getPic(option.file_name)">
              <img style="width: 120px; position: absolute;" alt="Gravsten overlay" class="gravestone-small-image" :src="getPic(option.file_name)">
              <div class="ml-05">
                <span class="headline">{{ option.name }}</span>
                <br>
                <span>{{ option.description }}</span>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: Object,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    selectGravestone: Function,
  },
  data() {
    return {
      selected: null,
      open: false,
    };
  },
  watch: {
    default: {
      handler() {
        this.selected = this.default;
      },
      deep: true,
    }
  },
  mounted() {
    this.selected = this.default;
  },
  methods: {
    getPic(file_name) {
      return process.env.VUE_APP_IMAGE_FOLDER + file_name;
    }
  }
};
</script>
<style scoped>
.gravestone-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  min-height: 47px;
}

.gravestone-select .selected {
  background-color: #fff;
  border: 1px solid #a5a5a5;
  color: #000;
  cursor: pointer;
  user-select: none;
}

.gravestone-select img {
  padding: 0.5rem;
  /*  -webkit-filter: drop-shadow(0 0 0 rgba(0,0,0,0.5)) drop-shadow(0 0 0 rgba(0,0,0,0.5));
  filter: drop-shadow(0 0 0 black) drop-shadow(0 0 0 black);*/
}

.gravestone-select .selected:after {
  position: absolute;
  content: "";
  top: 49%;
  right: 1em;
  width: 0;
  height: 0;
  border: 7.5px solid transparent;
  border-color: #000 transparent transparent transparent;
}

.gravestone-select .items {
  color: #fff;
  overflow: hidden;
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  z-index: 1;
  max-height: 379px;
  overflow: scroll;
}

.gravestone-select .items div {
  color: #000;
  cursor: pointer;
  user-select: none;
}

.gravestone-select .item {
  border-bottom: 1px solid #ddd;
}

.gravestone-select .items div:hover {
  background-color: #c3d2d0;
}

.gravestone-select .d-flex {
  align-items: center;
}

.gravestone-select .headline {
  font-size: 1rem;
}

.gravestone-select .active {
  background: #e1efed;
}

.selectHide {
  display: none;
}
</style>